import { Alert, Button, Stack, Typography } from '@mui/material';
import { PasswordChecklist } from 'components/shared/PasswordChecklist';
import { PasswordField } from 'components/shared/PasswordField';
import { observer } from 'mobx-react-lite';
import { KeyboardEvent } from 'react';
import { ChangePasswordStore } from 'stores/users/ChangePasswordStore';

type ChangePasswordProps = {
  changePasswordStore: ChangePasswordStore;
};

const ChangePassword = observer(({ changePasswordStore }: ChangePasswordProps) => {
  const { form, message, status, changePassword } = changePasswordStore;
  const newPasswordField = form.$('newPassword');

  const handleKeyInField = (evt: KeyboardEvent) => {
    if (evt.key === 'Enter') {
      evt.stopPropagation();
      evt.preventDefault();
      if (form.isValid) {
        changePassword();
      }
    }
  };

  return (
    <form autoComplete="off">
      <Stack spacing={4}>
        <Typography variant="h5">
          <strong>Change Password</strong>
        </Typography>
        {message && (
          <Alert aria-label="form-error" severity={status === 'error' ? 'error' : 'success'}>
            {message}
          </Alert>
        )}
        <PasswordField
          variant="outlined"
          autoComplete="current-password"
          onKeyDown={handleKeyInField}
          data-testid="oldPassword"
          required
          {...form.$('oldPassword').bind()}
          inputProps={{
            role: 'textbox',
          }}
        />
        <PasswordField
          variant="outlined"
          autoComplete="new-password"
          onKeyDown={handleKeyInField}
          data-testid="newPassword"
          required
          {...newPasswordField.bind()}
          inputProps={{
            role: 'textbox',
          }}
          helperText={undefined}
        />
        <PasswordChecklist style={{ marginTop: '16px' }} password={newPasswordField.value} />

        <Button
          variant="contained"
          disableElevation
          style={{ height: 56 }}
          disabled={!form.isValid}
          onClick={() => changePassword()}
        >
          Change Password
        </Button>
      </Stack>
    </form>
  );
});

export { ChangePassword };
